import React, { Fragment, useEffect, useState } from 'react';
import Common from '../../../Shared/Common';
import Block from '../../../Controls/Scafolding/Block';

import { Row, Col } from 'reactstrap';
import { TextHeader } from '../../../Controls/Digital/TextHeaders';

const Dates = (props) =>{

    const [blockName, setBlockName] = useState("");

    useEffect(() => {
        setBlockName(props.name);
        Common.traceInit("Block " + blockName);
    });

    return (
        <Block name="dates" isAlt={false}>

            <TextHeader text={
                <Fragment>
                    Dates to remember
                </Fragment>
            } />

            <ContentAboutWrapper
                header="The information night – Thursday 29th October Adreno Sydney"
                content={
                    <Fragment>
                        <p>
                            To kick off the biggest event on Sydney's spearfishing seasonal calendar we host a social & information night to bring the community together under one roof to set the scene for the following weekends event.
                        </p>
                        <p>
                            This Kingfish cup was born out of necessity, a competition built to bring our communities together in a sustainable and ethically focused competition with divers from all around Australia participating. A competition driven by inclusion, from the most experienced to aspiring greenhorn learning the ropes and piecing it together. This is what spearfishing is all about. Mateship, adventure, respect for the fishery and healthy competition.
                        </p>
                        <p>
                            The night’s goal is to share experiences and knowledge around Sydney Spearfishing with a focus on the Kingfish species. Feedback from you has been requested on the science of this fishery, and we are giving this to you on the night, An evening meal and refreshments (all free) catered by the Paella King Rico, throw in some sensational door prizes for those in attendance on the night, and to those who early bird register for the Cup there is a whopping major prize, the night is shaping up to be a ripper.
                        </p>
                        <p>
                            This social event will be bigger than the Cup itself! 
                        </p>
                    </Fragment>
                } />


            <ContentAboutWrapper
                header="Adreno Sydney Kingfish Cup  7 - 8th November"
                content={
                    <Fragment>
                    </Fragment>
                } />


            <ContentAboutWrapper
                header="The Presentation Thursday 12th November from 17:30 pm"
                content={
                    <Fragment>
                        <p>
                        Another fantastic social evening, where many of the entrants gather, again at Adreno Sydney Superstore, mingle and talk about the one that got away while enjoying some quality food while anticipating the results.
                        </p>
                        <p>
                            Come and be a part of our wonderful spearfishing community.
                        </p>
                    </Fragment>
                } />

        </Block>
    );
}
export default Dates;

const ContentAboutWrapper = (props) => {
    return (
        <Row>
            <Col lg={{ site: 10, offset: 1 }} className="definition">
                <p>
                    <b>{props.header}</b>
                </p>
                <p>
                    {props.content}
                </p>
            </Col>
        </Row>
    );
}